export default __webpack_public_path__ + "static/media/overnightDisabled.10e6fde3.svg";